<div class="ngx-datatable material" *ngIf="totalElements > 0">
    <div class="datatable-footer">
        <div class="datatable-footer-inner">
            <div>
                {{ totalElements }}
                {{ totalElements === 1 ? singularLabel : pluralLabel }}
            </div>
            <datatable-pager *ngIf="page"
                    [pagerLeftArrowIcon]="'datatable-icon-left'"
                    [pagerRightArrowIcon]="'datatable-icon-right'"
                    [pagerPreviousIcon]="'datatable-icon-prev'"
                    [pagerNextIcon]="'datatable-icon-skip'"
                    [page]="page.pageNumber + 1"
                    [size]="page.size"
                    [count]="totalElements"
                    [hidden]="!((totalElements / page.size) > 1)"
                    (change)="paginate($event)"
            >
            </datatable-pager>
        </div>
    </div>
</div>
